import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { meQuery } from "~/lib/auth";

/** Signed in but not yet onboarded (temporary password and/or no MFA). */
export const Route = createFileRoute("/_onboarding")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) throw redirect({ to: "/login" });
    if (me.onboarded) throw redirect({ to: "/dashboard" });
  },
  component: Outlet,
});
